import React from "react";
import { Button, FormControl, InputLabel, MenuItem, Select, TextField, makeStyles } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { AtsOption, ScrapeConfigFilters } from "../../Types/Scrapes";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    gap: "16px",
    alignItems: "center",
    marginBottom: "16px",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "stretch",
    },
  },
  filter: {
    minWidth: 180,
  },
}));

interface ScrapeFiltersProps {
  filters: ScrapeConfigFilters;
  onFilterChange: (filters: ScrapeConfigFilters) => void;
  atsOptions: AtsOption[];
  clientSearch: string;
  onClientSearchChange: (value: string) => void;
  onNewScrape: () => void;
}

export default function ScrapeFilters({
  filters,
  onFilterChange,
  atsOptions,
  clientSearch,
  onClientSearchChange,
  onNewScrape,
}: ScrapeFiltersProps) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <TextField
        label="Search Client"
        value={clientSearch}
        onChange={(e) => onClientSearchChange(e.target.value)}
        variant="outlined"
        size="small"
        className={classes.filter}
      />
      <FormControl variant="outlined" size="small" className={classes.filter}>
        <InputLabel>ATS</InputLabel>
        <Select
          value={filters.atsId || ""}
          onChange={(e) => onFilterChange({ ...filters, atsId: (e.target.value as string) || undefined })}
          label="ATS"
        >
          <MenuItem value="">All</MenuItem>
          {atsOptions.map((ats) => (
            <MenuItem key={ats.id} value={ats.id}>
              {ats.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <div style={{ flex: 1 }} />
      <Button variant="contained" color="primary" startIcon={<Add />} onClick={onNewScrape}>
        New Scrape
      </Button>
    </div>
  );
}
